import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=92c19a4a&scoped=true"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"
import style0 from "./NavTabs.vue?vue&type=style&index=0&id=92c19a4a&prod&scoped=true&lang=css"
import style1 from "./NavTabs.vue?vue&type=style&index=1&id=92c19a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c19a4a",
  null
  
)

export default component.exports